import { osiris } from '../api';
import BaseFetch from './base';

export default class Osiris extends BaseFetch {
    api = osiris
}
